import React, { Component } from 'react';
import {Form, Row, Col, Button} from 'react-bootstrap';
import InputText from '../common_components/InputText';
import DataDropdown from '../common_components/DataDropdown';
import {mapArrayToObject, getAPI, postAPI, validateForm, getLoggedInUser, getCurrencySymbol, showFormValidationAlert, constants} from '../common_components/common.js';
import Config from '../Config';
import '../FormPage.css'
const { Translate } = require('react-i18nify');
const token_expired = "Expired";

const validationFields = {
	realmId: "required",
	scope: "required",
	authCode: "required",
	accessToken: "required",
	refreshToken: "required",
};

export default class QBOConfig extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			errors: {},
			formData: {
				id: 0,
				appId: '',
				clientId: '',
				clientSecret: '',
				refreshTokenURI: '',
				redirectURI: '',
				baseURI: '',
				realmId: '',
				authCode: '',
				refreshToken: '',
				code: '',
				scope: '',
				intuitApiKey: '',
				accessToken: '',
				accessTokenExpireTime: '',
				refreshTokenExpireTime: '',
				strAccessTokenExpireTime: '',
				strRefreshTokenExpireTime: '',
				// mode: constants.qboMode,				
			},
			
			countriesList: [],
			statesList: [],
			observerAnglesList: [],
			illuminantsList: [],
			deltaETypesList: [],
			devicesList: [],
			bRefreshToken: true,
		};
		// this.handleInputChanged = this.handleInputChanged.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onQBOAuth = this.onQBOAuth.bind(this);
		this.formatExpiry = this.formatExpiry.bind(this);
		this.onRefreshAccessToken = this.onRefreshAccessToken.bind(this);
	}
	
	formatExpiry(utcDateString) {
		const expiryTime = new Date(utcDateString);
		const now = new Date();
		const diffMs = expiryTime - now;
		if(diffMs < 0)
			return token_expired;
		
		// Handle timezone conversion here if needed
		var hours = Math.floor(diffMs / 3600000);
		var res = '';
		if(hours >= 24) {
			
			var days = Math.floor(hours / 24);
			hours = hours & 24;
			res = `${days}d ${hours}h ${Math.floor((diffMs % 3600000) / 60000)}m`;
		} else {
			res = `${hours}h ${Math.floor((diffMs % 3600000) / 60000)}m`;
		}
		return res;
	}
	
	componentDidMount() {
		let formData = this.state.formData;
		var bRefreshToken = this.state.bRefreshToken;
		getAPI("/quickbooks").then(resCompany => {
			let formData = resCompany['data'][0];
			formData['strAccessTokenExpireTime'] = this.formatExpiry(formData['accessTokenExpireTime']);
			formData['strRefreshTokenExpireTime'] = this.formatExpiry(formData['refreshTokenExpireTime']);
			bRefreshToken = formData['strRefreshTokenExpireTime'] != token_expired;
			
			this.setState({
				formData: formData,
				bRefreshToken: bRefreshToken,
			});
		});
	}
	
	/*
	// Samee - I don't this is needed, we're no longer editing/saving any fields
	handleInputChanged(event, name) {
		const target = event.target;
		var value = target.type === 'checkbox' ? target.checked : target.value;
		var formData = this.state.formData;
		formData[name] = value;
		
		this.setState({
		  formData: formData,
		});
	}
	*/
	
	onSave() {
		const validation = validateForm(this.state.formData, validationFields);
		// IF FORM IS NOT VALIDATED, THEN SET STATE ACCORDINGLY
		if(!validation.result)
		{
			showFormValidationAlert(validation.errors);
			this.setState({
				errors: validation.errors
			});
		}
		else
		{
			// IF FORM IS VALIDATED PERFORM SAVE OPERATION HERE
			postAPI("quickbooks", this.state.formData).then(resCompanies => {
				alert("QBO Config Saved successfully.");
			});
		}
	}
	
	onQBOAuth() {
		const clientId = constants.qboClientId;
		const redirectUri = encodeURIComponent(constants.qboRedirectUri);
		const scopes = 'com.intuit.quickbooks.accounting';
		
		// Store the current tab (e.g., "qbo-config") in sessionStorage
		sessionStorage.setItem('postAuthRedirectTab', 'qbo-config');

		// Redirect to QuickBooks OAuth
		window.location.href = `https://appcenter.intuit.com/connect/oauth2?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scopes}&state=react_random_state`;
	}
	
	onRefreshAccessToken() {
		getAPI("common/qbrefreshtoken", this.state.formData).then(resRefreshToken => {
			console.log("before resRefreshToken: ", resRefreshToken);
			if(resRefreshToken != null && typeof resRefreshToken !== 'object')
				resRefreshToken = JSON.parse(resRefreshToken);
			console.log("after resRefreshToken: ", resRefreshToken);
			if(resRefreshToken['error'] != undefined) {
				var errMsg = resRefreshToken['error'];
				if(resRefreshToken['exception'] != undefined) {
					errMsg = resRefreshToken['exception'];
				}
				alert(errMsg);
			} else {
				alert("Access Token refreshed successfully.");
				this.componentDidMount();
			}
		});
	}

	render() {
		
		const loggedInUser = getLoggedInUser();
		
		return(
			<Form className='form-page' horizontal style={{maxHeight: 'none'}}>
				<Row>
					<Col md={12}>
						<h4><Translate value='components.settings.QBO Config' /></h4>
						<InputText required={validationFields.realmId == 'required'}
							label={<Translate value='components.settings.Realm Id' />} 
							name={'realmId'} value={this.state.formData.realmId} 
							errMsg={this.state.errors.realmId 
								? this.state.errors.realmId : ""}
						/>
						<InputText required={validationFields.scope == 'required'}
							label={<Translate value='components.settings.Scope' />} 
							name={'scope'} value={this.state.formData.scope} 
							errMsg={this.state.errors.scope 
								? this.state.errors.scope : ""}
						/>
						<InputText required={validationFields.authCode == 'required'}
							label={<Translate value='components.settings.Auth Code' />} 
							name={'authCode'} value={this.state.formData.authCode} 
							errMsg={this.state.errors.authCode 
								? this.state.errors.authCode : ""}
						/>
						<InputText required={validationFields.accessToken == 'required'}
							label={<Translate value='components.settings.Access Token' />} 
							name={'accessToken'} value={this.state.formData.accessToken} 
							type='TextArea'
							errMsg={this.state.errors.accessToken 
								? this.state.errors.accessToken : ""}
						/>
						<InputText required={validationFields.refreshToken == 'required'}
							label={<Translate value='components.settings.Refresh Token' />} 
							name={'refreshToken'} value={this.state.formData.refreshToken} 
							errMsg={this.state.errors.refreshToken 
								? this.state.errors.refreshToken : ""}
						/>
						<InputText
							label={<Translate value='components.settings.Access Token Expiry' />} 
							name={'accessTokenExpireTime'} 
							value={this.state.formData.strAccessTokenExpireTime} 
						/>
						<InputText
							label={<Translate value='components.settings.Refresh Token Expiry' />} 
							name={'refreshTokenExpireTime'} 
							value={this.state.formData.strRefreshTokenExpireTime} 
						/>
					</Col>
				</Row>
				<Row>
					<Col md={12}>
						{false && 
						<Button bsSize='sm'><Translate value='components.settings.cancel' /></Button>
						}
						&nbsp;
						{false && <Button bsSize='sm' bsStyle="primary" onClick={this.onSave}>
							<Translate value='components.settings.save' />
						</Button>
						}
						&nbsp;
						<Button bsSize='sm' bsStyle="primary" onClick={this.onQBOAuth}>
							<Translate value='components.settings.QBO Auth' />
						</Button>
						&nbsp;
						{this.state.bRefreshToken && 
						<Button bsSize='sm' bsStyle="primary" onClick={this.onRefreshAccessToken}>
							<Translate value='components.settings.Refresh Access Token' />
						</Button>
						}
					</Col>
				</Row>
			</Form>
		);
	}
}
